import { Button } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { darkenColor } from '../../../commonUtils';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};
export const BlockBoundaryAndOrientationSubmitButton = ({
  onClick,
  disabled = false,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Button
      variant='contained'
      size='medium'
      color='secondary'
      sx={{
        width: '100%',
        position: 'relative',
        whiteSpace: 'nowrap',
        border: (theme) => `1px solid ${theme.colors.secondary}`,
        '&.Mui-disabled': {
          color: '#dfdfdf87',
          bgcolor: (theme) => theme.colors.darkTheme.grey.medium,
        },
        transition: 'background-color 0.3s ease',
        bgcolor: (theme) => theme.colors.secondary,
        '&:hover': {
          bgcolor: (theme) => darkenColor(theme.colors.secondary, 0.2),
        },
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {t('Submit', { ns: 'common' })}
    </Button>
  );
};
